/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Save_Success_ToastInputs */

const en_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project saved successfully`)
};

const fr_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet enregistre avec succes`)
};

const de_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt erfolgreich gespeichert`)
};

const it_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto salvato con successo`)
};

const ru_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект успешно спасен`)
};

const es_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto guardado exitosamente`)
};

const zh_cn2_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目已成功保存`)
};

const ja_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトが正常に保存されました`)
};

const hi_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_explorer_display_save_success_toast = /** @type {(inputs: Explorer_Display_Save_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto salvo com sucesso`)
};

/**
* | output |
* | --- |
* | "Project saved successfully" |
*
* @param {Explorer_Display_Save_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_success_toast = /** @type {((inputs?: Explorer_Display_Save_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_save_success_toast(inputs)
	if (locale === "de") return de_explorer_display_save_success_toast(inputs)
	if (locale === "it") return it_explorer_display_save_success_toast(inputs)
	if (locale === "ru") return ru_explorer_display_save_success_toast(inputs)
	if (locale === "es") return es_explorer_display_save_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_save_success_toast(inputs)
	if (locale === "ja") return ja_explorer_display_save_success_toast(inputs)
	if (locale === "hi") return hi_explorer_display_save_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_save_success_toast(inputs)
	return en_explorer_display_save_success_toast(inputs)
});